import {useMutation} from '@github-ui/react-query'
import {apiUpdateIssueMilestoneBulk, type UpdateIssueMilestoneBulkRequest} from '../api/api-update-issue-milestone-bulk'
import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {Milestone} from '../api/milestone'

type UseUpdateIssueMilestoneBulkMutationInput = UpdateIssueMilestoneBulkRequest & {milestone?: Milestone}

type UseUpdateIssueMilestoneBulkMutationOptions = {
  onMutate: (variables: UseUpdateIssueMilestoneBulkMutationInput) => void
}

export function useUpdateIssueMilestoneBulkMutation({onMutate}: UseUpdateIssueMilestoneBulkMutationOptions) {
  return useMutation({
    mutationFn: async ({milestone, ...request}: UseUpdateIssueMilestoneBulkMutationInput) => {
      const responseJson = await apiUpdateIssueMilestoneBulk(request)
      const responseData = parseGraphQLResponse(responseJson)
      return responseData
    },
    onMutate,
  })
}
